import { render, staticRenderFns } from "./goods-status-select.vue?vue&type=template&id=65d97c66&"
import script from "./goods-status-select.vue?vue&type=script&lang=js&"
export * from "./goods-status-select.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports